import i18next from 'i18next'

import { FeatureFlagKeys } from '@hapana/shared/constants/feature-flag.constants'
import IconHome from '@hapana/shared/web/styles/assets/svgs/home.svg'
import IconChartLine from '@hapana/shared/web/styles/assets/svgs/chart-line.svg'
import IconMobile from '@hapana/shared/web/styles/assets/svgs/mobile.svg'
import IconApps from '@hapana/shared/web/styles/assets/svgs/apps.svg'
import hapanaLogo from '@hapana/shared/web/styles/assets/images/hapana-logo.png'
import i18n from '@hapana/shared/web/i18n'
import KeyIcon from '@hapana/shared/web/styles/assets/svgs/key-skeleton.svg'
import UserIcon from '@hapana/shared/web/styles/assets/svgs/user-small.svg'
import UsersIcon from '@hapana/shared/web/styles/assets/svgs/users.svg'
import downloadIcon from '@hapana/shared/web/styles/assets/svgs/download-small.svg'
import EllipsisH_Icon from '@hapana/shared/web/styles/assets/svgs/ellipsis-h.svg'
import ExportWidgets from '_components/export-widgets/export-widgets.component'
import IconSetting from '@hapana/shared/web/styles/assets/svgs/setting.svg'
import IconCreditCard from '@hapana/shared/web/styles/assets/svgs/credit-card-small.svg'
import IconPeople from '@hapana/shared/web/styles/assets/svgs/people-group.svg' // New clients icon from main
import IconCalendar from '@hapana/shared/web/styles/assets/svgs/calendar.svg'
import IconPlus from '@hapana/shared/web/styles/assets/svgs/plus-small.svg'
import IconMapMarker from '@hapana/shared/web/styles/assets/svgs/map-marker-alt-light-green.svg'
import IconHelpDocs from '@hapana/shared/web/styles/assets/svgs/file-alt.svg'
import IconFileGraph from '@hapana/shared/web/styles/assets/svgs/file-graph.svg'
import IconPlayCircle from '@hapana/shared/web/styles/assets/svgs/play-circle.svg'
import IconSearch from '@hapana/shared/web/styles/assets/svgs/search.svg'
import IconAssistant from '@hapana/shared/web/styles/assets/svgs/hapana-ai-icon.svg'

import { ROUTES } from '../../app.constants'
export const image = {
  alt: 'Alt text',
  openedSrc: hapanaLogo,
  closedSrc: hapanaLogo,
}

export const navItems = {
  withoutLocation: {
    main: [
      {
        icon: IconHome,
        id: 'home',
        label: i18n.t('common:navigationLinks.dashboard'),
        href: '/',
      },
      {
        icon: IconChartLine,
        id: 'reports',
        label: i18n.t('common:navigationLinks.reports'),
        href: '/reports',
      },
      // {
      //   icon: IconMobile,
      //   id: 'mobile-setup',
      //   label: i18n.t('common:navigationLinks.mobileSetup', 'Mobile Setup'),
      //   href: '/c/control-center/self-service',
      // }, Already exists in controls -> /control-center/self-service
      {
        icon: IconPlayCircle,
        id: 'contentSuite',
        label: i18n.t('common:navigationLinks.contentSuite'),
        href: `/c/${ROUTES.contentSuite.path}`,
        featureFlag: FeatureFlagKeys.ContentSuiteEnabled,
      },

      {
        icon: IconHelpDocs,
        id: 'help-docs',
        label: i18n.t('common:navigationLinks.helpDocs'),
        href: `/${ROUTES.helpDocs.path}`,
      },
      {
        icon: IconApps,
        id: 'control-center',
        label: i18n.t('common:navigationLinks.control'),
        href: '/control-center',
      },
      {
        icon: IconAssistant,
        id: 'assistant',
        label: i18n.t('common:navigationLinks.assistant', 'Assistant'),
        href: `/${ROUTES.assistant.path}`,
        featureFlag: FeatureFlagKeys.AssistantSidenavEnabled,
      },
    ],
    // quickSearch: {
    //   icon: QuickSearchIcon,
    //   label: i18n.t('admin:navigation.links.quickSearch'),
    //   href: 'brands',
    //   component: <></>, // will update Component on Implementation
    // },
  },
  // quickSearch: {
  //   icon: QuickSearchIcon,
  //   label: i18n.t('admin:navigation.links.quickSearch'),
  //   component: <> </>, // will update Component on Implementation
  //   grayedOut: true,
  // },
  withLocation: {
    main: [
      {
        icon: IconHome,
        id: 'home',
        label: i18n.t('common:navigationLinks.dashboard'),
        href: '/',
      },
      {
        icon: IconChartLine,
        id: 'reports',
        label: i18n.t('common:navigationLinks.reports'),
        href: '/reports',
      },
      {
        icon: IconPeople,
        id: 'clients',
        label: i18n.t('core:clients.title'),
        href: '/clients',
      },
      {
        icon: IconMobile,
        id: 'mobile-setup',
        label: i18n.t('common:navigationLinks.mobileSetup'),
        href: '/c/control-center/self-service',
      },
      {
        icon: IconPlayCircle,
        id: 'contentSuite',
        label: i18n.t('common:navigationLinks.contentSuite'),
        href: `/${ROUTES.contentSuite.path}`,
        featureFlag: FeatureFlagKeys.ContentSuiteEnabled,
      },
      {
        icon: IconSetting,
        id: 'location-settings',
        label: i18n.t('common:navigationLinks.locations'),
        href: '/settings',
      },
      {
        icon: IconCreditCard,
        id: 'retail',
        label: i18n.t('core:navigationLinks.retail'),
        href: '/retail',
      },
      {
        icon: IconHelpDocs,
        id: 'help-docs',
        label: i18n.t('common:navigationLinks.helpDocs'),
        href: `/${ROUTES.helpDocs.path}`,
      },
      {
        icon: IconApps,
        id: 'control-center',
        label: i18n.t('common:navigationLinks.control'),
        href: '/control-center',
      },
      {
        icon: IconSetting,
        id: 'settings',
        label: i18n.t('common:navigationLinks.settings'),
        href: '/settings',
        requiresSiteId: true,
      },
      {
        icon: IconAssistant,
        id: 'assistant',
        label: i18n.t('common:navigationLinks.assistant', 'Assistant'),
        href: `/${ROUTES.assistant.path}`,
        featureFlag: FeatureFlagKeys.AssistantSidenavEnabled,
      },
    ],
    // quickSearch: {
    //   icon: QuickSearchIcon,
    //   label: i18n.t('admin:navigation.links.quickSearch'),
    //   component: <> </>, // will update Component on Implementation
    //   grayedOut: true,
    // },
    // custom: [
    // {
    //   icon: IconFileGraph,
    //   id: 'financesSheet',
    //   onClick: () => null,
    //   label: i18n.t('common:navigationLinks.financesSheet'),
    //   grayedOut: true,
    // },
    // {
    //   icon: IconFileGraph,
    //   id: 'email',
    //   onClick: () => null,
    //   label: i18n.t('common:navigationLinks.email'),
    //   grayedOut: true,
    // },
    // ],
  },

  bottomDefault: [
    // {
    //   id: 'helpCenter',
    //   label: i18n.t('common:navigationLinks.helpCenter'),
    //   route: 'help-center',
    //   icon: QuestonCircle,
    //   onClick: () => null,
    //   grayedOut: true,
    // },
    {
      id: 'access',
      label: i18n.t('common:navigationLinks.access'),
      icon: KeyIcon,
      href: '/user-access',
      onClick: () => null,
    },
  ],
  userProfile: {
    id: 'profile',
    label: i18n.t('common:navigationLinks.myProfile'),
    route: '/profile',
    alt: i18next.t('admin:navigation.avatarAlt'),
  },
  teamAccess: {
    id: 'teamAccess',
    label: i18n.t('common:navigationLinks.teamAccess'),
    icon: KeyIcon,
    route: '/team-access',
    onClick: () => null,
    requiresSiteId: true,
  },
}

export const BOTTOM_NAVIGATIONS = {
  // loc: [
  //   {
  //     label: i18n.t('common:navigationLinks.goToLocation'),
  //     icon: IconMapMarker,
  //     id: 'goToLocation',
  //   },
  // ],
  withoutLocation: {
    bottomNavItems: [
      {
        icon: IconHome,
        id: 'home',
        label: i18n.t('common:navigationLinks.home'),
        href: '/',
      },
      {
        icon: IconApps,
        id: 'control-center',
        label: i18n.t('common:navigationLinks.controlCenter'),
        href: '/control-center',
      },
      {
        id: 'More',
        label: i18n.t('common:navigationLinks.more'),
        href: null,
        icon: EllipsisH_Icon,
      },
    ],
    main: [
      {
        icon: IconChartLine,
        id: 'reports',
        label: i18n.t('common:navigationLinks.reports'),
        href: '/reports',
      },
      {
        icon: IconHelpDocs,
        id: 'help-docs',
        label: i18n.t('common:navigationLinks.helpDocs'),
        href: `/${ROUTES.helpDocs.path}`,
      },
    ],
    bottomDefault: [
      {
        id: 'access',
        label: i18n.t('common:navigationLinks.access'),
        icon: KeyIcon,
        href: '/user-access',
        onClick: () => null,
      },
    ],
    userProfile: {
      id: 'profile',
      label: i18n.t('common:navigationLinks.myProfile'),
      route: '/profile',
      alt: i18next.t('admin:navigation.avatarAlt'),
    },
  },
  // quickSearch: {
  //   icon: QuickSearchIcon,
  //   label: i18n.t('admin:navigation.links.quickSearch'),
  //   component: <></>, // will update Component on Implementation
  //   grayedOut: true,
  // },
  withLocation: {
    bottomNavItems: [
      {
        icon: IconHome,
        id: 'home',
        label: i18n.t('common:navigationLinks.home'),
        href: '/',
      },
      // {
      //   icon: IconMobile,
      //   id: 'apps',
      //   label: i18n.t('common:navigationLinks.apps'),
      //   href: 'apps',
      //   grayedOut: true,
      // },
      // {
      //   icon: IconMapMarker,
      //   id: 'locations',
      //   label: i18n.t('common:navigationLinks.locations'),
      //   href: 'locations',
      //   grayedOut: true,
      // },
      {
        id: 'More',
        label: i18n.t('common:navigationLinks.more'),
        href: null,
        icon: EllipsisH_Icon,
      },
    ],
    main: [
      // {
      //   icon: IconGraphBar,
      //   id: 'leaderboard',
      //   label: i18n.t('common:navigationLinks.leaderboard'),
      //   href: 'leaderboard',
      //   grayedOut: true,
      // },
      // {
      //   icon: IconPlayCircle,
      //   id: 'contentSuite',
      //   label: i18n.t('common:navigationLinks.contentSuite'),
      //   href: 'content-suite',
      //   grayedOut: true,
      // },
      // {
      //   icon: UsersIcon,
      //   id: 'teamAccess',
      //   label: i18n.t('common:navigationLinks.teamAccess'),
      //   href: 'team-access',
      //   grayedOut: true,
      // },
      {
        icon: IconSetting,
        id: 'location-settings',
        label: i18n.t('common:navigationLinks.locations'),
        href: '/settings',
        onClick: () => null,
      },
      {
        icon: IconApps,
        id: 'control-center',
        label: i18n.t('common:navigationLinks.control'),
        href: '/control-center',
      },
    ],
    // custom: [
    // {
    //   icon: IconFileGraph,
    //   id: 'financesSheet',
    //   onClick: () => null,
    //   label: i18n.t('common:navigationLinks.financesSheet'),
    //   grayedOut: true,
    // },
    // {
    //   icon: IconFileGraph,
    //   id: 'email',
    //   onClick: () => null,
    //   label: i18n.t('common:navigationLinks.email'),
    //   grayedOut: true,
    // },
    // ],

    actionItem: {
      id: 'viewExport',
      label: i18n.t('common:navigationLinks.viewExport'),
      href: null,
      component: ExportWidgets,
      icon: downloadIcon,
    },

    bottomDefault: [
      // {
      //   id: 'helpCenter',
      //   label: i18n.t('common:navigationLinks.helpCenter'),
      //   href: 'help-center',
      //   icon: QuestonCircle,
      //   onClick: () => null,
      //   grayedOut: true,
      // },

      {
        id: 'access',
        label: i18n.t('common:navigationLinks.access'),
        icon: KeyIcon,
        href: '/user-access',
        onClick: () => null,
      },
    ],
    userProfile: {
      id: 'profile',
      label: i18n.t('common:navigationLinks.myProfile'),
      route: '/profile',
      alt: i18next.t('admin:navigation.avatarAlt'),
    },
    teamAccess: {
      id: 'teamAccess',
      label: i18n.t('common:navigationLinks.teamAccess'),
      icon: KeyIcon,
      route: '/team-access',
      onClick: () => null,
      requiresSiteId: true,
    },
  },
}

// Location-level navigation items (when a site is selected)
export const locationNavItems = {
  withLocation: {
    main: [
      {
        icon: IconHome,
        id: 'home',
        label: i18n.t('common:navigationLinks.home'),
        href: '/',
      },
      {
        icon: IconCalendar,
        id: 'schedule',
        label: i18n.t('common:navigationLinks.schedule'),
        href: '/schedule',
      },
      {
        icon: IconPeople,
        id: 'clients',
        label: i18n.t('core:clients.title'),
        href: '/clients',
      },
      {
        icon: IconCreditCard,
        id: 'payments',
        label: i18n.t('common:navigationLinks.payments'),
        href: '/retail',
      },
      {
        icon: IconChartLine,
        id: 'reports',
        label: i18n.t('common:navigationLinks.reports'),
        href: '/reports',
      },
      {
        icon: IconHelpDocs,
        id: 'help-docs',
        label: i18n.t('common:navigationLinks.helpDocs'),
        href: `/${ROUTES.helpDocs.path}`,
      },
      {
        icon: IconSetting,
        id: 'settings',
        label: i18n.t('common:navigationLinks.settings'),
        href: '/settings',
      },
      {
        icon: IconAssistant,
        id: 'assistant',
        label: i18n.t('common:navigationLinks.assistant', 'Assistant'),
        href: `/${ROUTES.assistant.path}`,
        featureFlag: FeatureFlagKeys.AssistantSidenavEnabled,
      },
    ],
    actionItem: {
      icon: IconPlus,
      id: 'new-sale',
      label: i18n.t('common:navigationLinks.newSale'),
      href: '/new-sale',
    },
  },
}

export const ROUTES_WITHOUT_BREADCRUMBS = [
  ROUTES.login.path,
  ROUTES.userProfile.path,
  ROUTES.loginAs.path,
  ROUTES.accessDenied.path,
  ROUTES.notFound.path,
  ROUTES.logout.path,
  ROUTES.clients.pathWithSlash,
  ROUTES.clients.children.clientOverview.pathWithSlash,
  ROUTES.mobileSetup.path,
  ROUTES.locationSelection.path,
  `/${ROUTES.retailDashboard.path}`,
  ROUTES.assistant.path,
]
